import React, { useState } from "react";
import HalfLogo from "../../assets/halfLogo.png";
import Bell from "../../assets/bellIcon.png";
import MenuBar from "../../assets/menuBar.png";
import SideBar from "./SideBar";

const MobileViewHeader = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

  return (
    <>
      <div className="mobile-header-root">
        <div className="mh-leftSide">
          <img src={HalfLogo} alt="half-logo" className="mh-hl" />
        </div>
        <div className="mh-right-side">
          <img src={Bell} alt="bell-icon" className="mh-bell" />
          <img
            src={MenuBar}
            alt="menuBar-icon"
            className="mh-menuBar"
            onClick={toggleSidebar}
          />
        </div>
      </div>

      {/* Conditionally render sidebar */}
      {isSidebarOpen && (
        <div className="sidebar-overlay" onClick={toggleSidebar}>
          <div
            className="sidebar-slide-in"
            onClick={(e) => e.stopPropagation()}
          >
            <SideBar onClose={toggleSidebar} />
          </div>
        </div>
      )}
    </>
  );
};

export default MobileViewHeader;
